const zh = {
  message: {
    'home': '首页',
    'product': '产品',
    'newcenter': '新闻中心',
    'resource': '资源中心',
    'aboutus': '关于我们',
    'agent': '代理加盟',
    'cooperation': '商务合作',
    'with': '找CEO谈',
    'contact': '点击联系我',
    'email': '邮箱',
    'code': '微信扫一扫关注公众号',
    'time': '周一至周日09:00-18:00',
    'company': ' 深圳市劳乐斯科技有限公司 版权所有 ',
    'record':'粤ICP备2025429618号',
    'list': ' 趣芯 APP 已上架：',
    'application': ' 应用宝 ',
    'store': ' 根据手机类型和地区选择应用商店 ',
    'install': '进行下载安装',
    'download': '下载',
    'name': '名称',
    'picture': '图片',
    'times': '时间',
    'productlist': '产品列表',
    'codes': '编号',
    'material': '材质',
    'color': '颜色',
    'brand': '品牌',
    'function': '功能',
    'consult': '联系客服',
    'prev': '上一个',
    'next': '下一个',
    'click': '点击下载',
    'pack': '打包下载',
    'volume': '体积',
  }
}
export default zh